"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _AjaxContent = _interopRequireDefault(require("../../modules/AjaxContent"));

var _Modal = _interopRequireDefault(require("../../modules/Modal"));

var _AnchorTypes = require("./AnchorTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Anchor = /*#__PURE__*/function (_React$Component) {
  _inherits(Anchor, _React$Component);

  var _super = _createSuper(Anchor);

  function Anchor() {
    var _this;

    _classCallCheck(this, Anchor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", (0, _classNames["default"])(Anchor.displayName));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isModalOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function () {
      _this.setState({
        isModalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      event.preventDefault();

      if (_this.props.onClick) {
        _this.props.onClick();
      } else {
        _this.setState({
          isModalOpen: true
        });
      }
    });

    return _this;
  }

  _createClass(Anchor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contentLocation = _this$props.contentLocation,
          disabled = _this$props.disabled,
          download = _this$props.download,
          fallbackElementTag = _this$props.fallbackElementTag,
          href = _this$props.href,
          kind = _this$props.kind,
          modalLabel = _this$props.modalLabel,
          newWindow = _this$props.newWindow,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick,
          reactFromMarkupOptions = _this$props.reactFromMarkupOptions,
          reactFromMarkupRehydrators = _this$props.reactFromMarkupRehydrators,
          children = _this$props.children,
          innerRef = _this$props.innerRef,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? "" : _this$props$title,
          id = _this$props.id,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["contentLocation", "disabled", "download", "fallbackElementTag", "href", "kind", "modalLabel", "newWindow", "onChange", "onClick", "reactFromMarkupOptions", "reactFromMarkupRehydrators", "children", "innerRef", "title", "id", "className"]);

      var classNameFull = "".concat(this.getClassName(), " ").concat(className || ""); // eslint-disable-next-line
      // TODO: AnchorElement should be its own component

      var elementProps = {
        title: title
      };
      var AnchorElement;

      if (innerRef) {
        elementProps.ref = innerRef;
      } // eslint-disable-next-line
      // TODO: clean up this flow control, its hard to follow


      if (kind === _AnchorTypes.AnchorElementKind.LINK) {
        AnchorElement = fallbackElementTag;

        if (href) {
          AnchorElement = _AnchorTypes.AnchorElementTags.LINK;
          elementProps.href = href;
          elementProps.download = download;
        }

        if (newWindow) {
          elementProps.target = "_blank";
          elementProps.rel = "noopener";
        }
      } else {
        AnchorElement = _AnchorTypes.AnchorElementTags.BUTTON;
        elementProps.type = kind;
        elementProps.disabled = disabled;
      }

      var shouldRehydrate = Boolean(contentLocation);
      /**
       * `data-content-modal` provides us an identifier which
       * the wel-trdotcom global modal click handlers can
       * match against.
       */

      if (shouldRehydrate) {
        elementProps["data-content-location"] = contentLocation;
        elementProps["data-modal-label"] = modalLabel;
        elementProps["data-content-modal"] = true;
      }

      if (id) {
        elementProps.id = id;
      }

      var shouldHandleClick = contentLocation || onClick;

      if (shouldHandleClick) {
        elementProps.onClick = this.handleOnClick;
      }

      return /*#__PURE__*/_react["default"].createElement(AnchorElement, _extends({
        className: classNameFull
      }, elementProps, rest), children, this.state.isModalOpen && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        ariaLabel: modalLabel,
        closeLabel: "Close",
        closeThisComponent: this.handleCloseModal
      }, /*#__PURE__*/_react["default"].createElement(_AjaxContent["default"], {
        failedContent: "Failed to retrieve content",
        loadingLabel: "Loading",
        location: contentLocation,
        onChange: onChange,
        reactFromMarkupOptions: reactFromMarkupOptions,
        reactFromMarkupRehydrators: reactFromMarkupRehydrators
      })));
    }
  }]);

  return Anchor;
}(_react["default"].Component);

_defineProperty(Anchor, "displayName", "Anchor");

_defineProperty(Anchor, "defaultProps", {
  kind: _AnchorTypes.AnchorElementKind.LINK,
  fallbackElementTag: _AnchorTypes.AnchorElementTags.SPAN
});

var _default = Anchor;
exports["default"] = _default;